// extracted by mini-css-extract-plugin
export var dropdownButton = "_28-0";
export var fullWidthDropdownButton = "_28-1";
export var icon = "_28-3";
export var iconPlaceholder = "_28-2";
export var menuItemRow = "_28-9";
export var separator = "_28-e";
export var shortcutContainer = "_28-7";
export var shortcutContainerFilled = "_28-8";
export var shortcutIconLg = "_28-6";
export var shortcutIconMd = "_28-5";
export var shortcutIconSm = "_28-4";
export var submenuChevron = "_28-d";
export var submenuDropdown = "_28-a";
export var submenuTriggerRow = "_28-b";
export var submenuTriggerRowOpen = "_28-c";